import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const listApi = createApi({
  reducerPath: 'listApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['Listing'],
  refetchOnMountOrArgChange: 1,
  endpoints: (builder) => ({

    getBookItems: builder.query({
      query: (data) => {
        return {
          url: `book_items?page=${data.page}&size=${data.size}&state=${data.state}&language=${data.language}&assignee=${data.assignee}&status=${data.status}&category=${data.category}&product_status=${data.product_status}`,
          method: 'GET',
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['Listing'],
    }),


    getTaskList: builder.query({
      query: (data) => {
        return {
          url: `tasks/${data.userId}?page=${data.page}&size=${data.size}&status=${data.status}`,
          method: 'GET',
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['Listing'],
    }),


    getSearchUser: builder.query({
      query: (data) => {
        return {
          url: `users/${data.query}`,
          method: 'GET',
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['Listing'],
    }),


    updateTask: builder.mutation({
      query: (data) => {
        return {
          url: `tasks/${data.id}`,
          method: 'PUT',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Listing'],
    }),

    createTask: builder.mutation({
      query: (data) => {
        return {
          url: `tasks/${data.id}`,
          method: 'POST',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Listing'],
    }),


    createTaskComment: builder.mutation({
      query: (data) => {
  

        const formData = new FormData();
        formData.append('myFile', data.task_file);
        formData.set('comment', data.task_comment);
        return {
          url: `comments/${data.id}`,
          method: 'POST',
          body: formData,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            // 'Accept': 'application/json',
            // 'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Listing'],
    }),





  }),
})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
  useGetBookItemsQuery,
  useGetTaskListQuery,
  useGetSearchUserQuery,
  useUpdateTaskMutation,
  useCreateTaskMutation,
  useCreateTaskCommentMutation
} = listApi